import { lazy } from 'react';
import { AUDIT_READ_USERS } from 'src/services/auditService';

export const caseRoutes = () => [
  {
    page: 'Worksheet',
    path: 'referral/worksheet',
    component: lazy(() => import('src/views/case/NewCaseWorksheetView')),
    permission: {
      readPermission: 'read:referralWorksheet',
      createPermission: 'create:referralWorksheet',
      updatePermission: 'update:referralWorksheet',
    },
  },
  {
    form: 'caseSummary',
    page: 'Summary',
    path: 'referral/summary',
    component: lazy(() => import('src/views/case/CaseSummaryView')),
    permission: {
      readPermission: 'read:referralSummary',
      createPermission: 'upsert:referralSummary',
      updatePermission: 'upsert:referralSummary',
    },
  },
  {
    form: 'donorScreening',
    page: 'Preliminary Donor Screening',
    path: 'referral/screening',
    component: lazy(() => import('src/views/case/DonorScreeningView')),
    permission: {
      readPermission: 'read:referralDonorScreening',
      createPermission: 'create:referralDonorScreening',
      updatePermission: 'update:referralDonorScreening',
    },
  },
  {
    form: 'casePreliminaryHemodilution',
    page: 'PreliminaryHemodilution',
    path: 'referral/preliminaryHemodilution',
    component: lazy(() => import('src/views/case/PreliminaryHemodilution')),
    permission: {
      readPermission: 'read:referralPreliminaryHemodilution',
      createPermission: 'upsert:referralPreliminaryHemodilution',
      updatePermission: 'upsert:referralPreliminaryHemodilution',
    },
  },
  {
    page: 'Donation Discussion',
    path: 'referral/discussion',
    component: lazy(
      () =>
        import('src/views/case/DonationDiscussionView/DonationDiscussionView'),
    ),
    permission: {
      readPermission: 'read:referralDonationDiscussion',
      createPermission: 'upsert:referralDonationDiscussion',
      updatePermission: 'upsert:referralDonationDiscussion',
    },
  },
  {
    page: 'Authorized Usage',
    path: 'referral/usage',
    component: lazy(
      () => import('src/views/case/AuthorizedUsageView/AuthorizedUsageView'),
    ),
    permission: {
      readPermission: 'read:authForm',
      createPermission: 'create:authForm',
      updatePermission: 'update:authForm',
    },
  },
  {
    page: 'Dispatch',
    path: 'referral/dispatch',
    component: lazy(
      () => import('src/views/case/DispatchDashboard/DispatchDashboard'),
    ),
    permission: {
      readPermission: 'read:dispatch',
      createPermission: 'create:dispatch',
      updatePermission: 'update:dispatch',
    },
  },
  {
    page: 'Hemodilution',
    path: 'medicalReview/hemodilution',
    component: lazy(() => import('src/views/medicalReview/Hemodilution')),
    permission: {
      readPermission: 'read:medicalReviewHemodilution',
      createPermission: 'upsert:medicalReviewHemodilution',
      updatePermission: 'upsert:medicalReviewHemodilution',
    },
  },
  {
    path: 'notes',
    page: 'Notes',
    component: lazy(
      () => import('src/views/notes/CaseNotesList/CaseNotesTransmit'),
    ),
    permission: {
      readPermission: 'read:notes',
      createPermission: 'create:notes',
      updatePermission: 'update:notes',
    },
  },
  {
    path: 'checklist',
    page: 'Checklist',
    component: lazy(
      () => import('src/views/checklist/ChecklistView/CaseChecklistTransmit'),
    ),
  },
  {
    path: 'tasks',
    page: 'Tasks',
    component: lazy(() => import('src/views/tasks/CaseTasks/CaseTaskTransmit')),
  },
  {
    path: 'medSocial',
    component: lazy(() => import('src/views/case/DRAIView')),
  },
  {
    form: 'medSocial',
    page: 'DRAI',
    path: 'medSocial/:draiId',
    component: lazy(() => import('src/views/case/DRAIView')),
    permission: {
      readPermission: 'read:medicalSocialDrai',
      updatePermission: 'update:medicalSocialDrai',
      createPermission: 'create:medicalSocialDrai',
    },
  },
  {
    form: 'medSocial',
    page: 'DRAI',
    path: 'medSocial/:draiId/:draiType',
    component: lazy(() => import('src/views/case/DRAIView')),
    permission: {
      readPermission: 'read:medicalSocialDrai',
      updatePermission: 'update:medicalSocialDrai',
      createPermission: 'create:medicalSocialDrai',
    },
  },
  {
    form: 'medReview',
    page: 'Culture Results',
    path: 'medicalReview/cultureResults',
    component: lazy(() => import('src/views/medicalReview/CultureResults')),
    permission: {
      readPermission: 'read:medicalReviewCultureResult',
      createPermission: 'upsert:medicalReviewCultureResult',
      updatePermission: 'upsert:medicalReviewCultureResult',
    },
  },
  {
    form: 'medicalReviewPathology',
    page: 'Pathology',
    path: 'medicalReview/pathology',
    component: lazy(() => import('src/views/medicalReview/PathologyView')),
    permission: {
      readPermission: 'read:medicalReviewPathology',
      createPermission: 'create:medicalReviewPathology',
      updatePermission: 'update:medicalReviewPathology',
    },
  },
  {
    form: 'medicalReviewSerology',
    page: 'Serologies',
    path: 'medicalReview/serologies',
    component: lazy(() => import('src/views/medicalReview/Serologies')),
    permission: {
      readPermission: 'read:medicalReviewSerology',
      createPermission: 'create:medicalReviewSerology',
      updatePermission: 'update:medicalReviewSerology',
    },
  },
  {
    form: 'medicalReviewSummary',
    page: 'Medical Review',
    path: 'medicalReview/summary',
    component: lazy(() => import('src/views/medicalReview/Summary')),
    permission: {
      readPermission: 'read:medicalReviewSummary',
      createPermission: 'upsert:medicalReviewSummary',
      updatePermission: 'upsert:medicalReviewSummary',
    },
  },
  {
    page: 'Serologies',
    path: 'medicalReview/serologies/all',
    component: lazy(
      () => import('src/views/medicalReview/Serologies/SerologiesTransmit'),
    ),
    permission: {
      readPermission: 'read:medicalReviewSerology',
      createPermission: 'create:medicalReviewSerology',
      updatePermission: 'update:medicalReviewSerology',
    },
  },
  {
    form: 'medicalReviewSerology',
    page: 'Serologies',
    path: 'medicalReview/serologies/:serologyId',
    component: lazy(() => import('src/views/medicalReview/Serologies')),
    permission: {
      readPermission: 'read:medicalReviewSerology',
      createPermission: 'create:medicalReviewSerology',
      updatePermission: 'update:medicalReviewSerology',
    },
  },
  {
    page: 'Audit',
    path: 'audit',
    component: lazy(() => import('src/views/audit/AuditView')),
    permission: {
      readPermission: AUDIT_READ_USERS,
    },
  },

  {
    page: 'Pathology',
    path: 'medicalReview/pathology',
    component: lazy(() => import('src/views/medicalReview/PathologyView')),
    permission: {
      readPermission: 'read:medicalReviewPathology',
      createPermission: 'create:medicalReviewPathology',
      updatePermission: 'update:medicalReviewPathology',
    },
  },
  {
    page: 'Lab Values',
    form: 'labValues',
    path: 'medicalReview/labValues',
    component: lazy(() => import('src/views/medicalReview/LabValues')),
    permission: {
      readPermission: 'read:medicalReviewLabValues',
      createPermission: 'upsert:medicalReviewLabValues',
      updatePermission: 'upsert:medicalReviewLabValues',
    },
  },
  {
    page: 'Attachments',
    path: 'attachments',
    component: lazy(() => import('src/views/attachments/AttachmentsView')),
  },

  {
    path: 'transmit/log',
    page: 'Transmit Log',
    component: lazy(() => import('src/views/transmit/LogView')),
    permissions: {
      readPermission: 'read:transmitLog',
    },
  },
  {
    page: 'Transmit Data',
    form: 'transmitData',
    path: 'transmit/data',
    component: lazy(() => import('src/views/transmit/DataView')),
    permissions: {
      readPermission: 'read:transmit',
      createPermission: 'create:transmit',
      updatePermission: 'update:transmit',
    },
  },

  {
    path: 'approvals/approval',
    page: 'Approval',
    form: 'approval',
    component: lazy(() => import('src/views/approvals/Approval')),
    permission: {
      readPermission: 'read:approval',
      createPermission: 'create:approval',
      updatePermission: 'update:approval',
    },
  },
  {
    path: 'approvals/lock',
    page: 'Case Lock',
    form: 'approvalsCaseLock',
    component: lazy(() => import('src/views/approvals/CaseLockView')),
    permission: {
      readPermission: 'read:caseLock',
      createPermission: 'update:caseLock',
      updatePermission: 'update:caseLock',
    },
  },
  {
    path: 'approvals/disposition',
    page: 'Disposition',
    component: lazy(() => import('src/views/approvals/Disposition')),
    permission: {
      readPermission: 'read:disposition',
    },
  },
  {
    path: 'referral/authorizations',
    component: lazy(() => import('src/views/case/AuthFormView')),
  },
  {
    form: 'authForm',
    page: 'Authorizations',
    path: 'referral/authorizations/:authFormId',
    component: lazy(() => import('src/views/case/AuthFormView')),
    permission: {
      readPermission: 'read:authForm',
      createPermission: 'create:authForm',
      updatePermission: 'update:authForm',
    },
  },
];
